// extracted by mini-css-extract-plugin
export default {"main":"main--xYZ2R","map":"map--mMJsb","preloader":"preloader--_SJN2","lds-ring":"lds-ring--CrCS8","ldsRing":"lds-ring--CrCS8"};